import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=0cd86f1e"
import script from "./UploadFile.vue?vue&type=script&lang=js"
export * from "./UploadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports